import i18n from "i18next";
import commonEn from "./en/common.json";
import commonHi from "./hi/common.json";
import liveClassEn from "./en/live-class.json";
import agoraEn from "./en/agora.json";
import authEn from "./en/auth.json";
import authHi from "./hi/auth.json";
import introEn from "./en/intro.json";
import introHi from "./hi/intro.json";

import doubtEn from "./en/doubt.json";
import doubtHi from "./hi/doubt.json";
import contactUsEn from "./en/contactUs.json";
import subscriptionsEn from "./en/subscriptions.json";
import subscriptionsHi from "./hi/subscriptions.json";
import testsEn from "./en/tests.json";
import testsHi from "./hi/tests.json";
import doubtsEn from "./en/doubts.json";
import doubtsHi from "./hi/doubts.json";
import selflearnEn from "./en/selflearn.json";
import profileEn from "./en/profile.json";
import bookmarksEn from "./en/bookmarks.json";
import referralEn from "./en/referral.json";
import bookmarkHi from "./hi/bookmark.json";
import reportsEn from "./en/reports.json";
import reportsHi from "./hi/reports.json";
import liveClassHi from "./hi/live-class.json";
import scaLoginEn from "./en/scaLogin.json";
import ainaIntroEn from "./en/ainaIntro.json";
import ainaIntroHi from "./hi/ainaIntro.json";
import smartBatchingEn from "./en/smartBatching.json";
import smartBatchingHi from "./hi/smartBatching.json";
import profileSetupEn from "./en/profileSetup.json";
import paidUserOnboardingEn from "./en/paidUserOnboarding.json";
import paidUserOnboardingHi from "./hi/paidUserOnboarding.json";

export const resources = {
  en: {
    common: commonEn,
    agora: agoraEn,
    "live-class": liveClassEn,
    auth: authEn,
    doubt: doubtEn,
    contactUs: contactUsEn,
    intro: introEn,
    subscriptions: subscriptionsEn,
    tests: testsEn,
    doubts: doubtsEn,
    selflearn: selflearnEn,
    profile: profileEn,
    bookmarks: bookmarksEn,
    referral: referralEn,
    reports: reportsEn,
    scaLogin: scaLoginEn,
    ainaIntro: ainaIntroEn,
    smartBatching: smartBatchingEn,
    profileSetup: profileSetupEn,
    paidUserOnboarding: paidUserOnboardingEn,
  },
  hi: {
    common: commonHi,
    auth: authHi,
    contactUs: contactUsEn, // Fallback to EN for now
    intro: introHi,
    "live-class": liveClassHi,
    subscriptions: subscriptionsHi,
    tests: testsHi,
    doubts: doubtsHi,
    selflearn: selflearnEn, // Fallback to EN for now
    profile: profileEn, // Fallback to EN for now
    bookmarks: bookmarkHi,
    doubt: doubtHi,
    reports: reportsHi,
    scaLogin: scaLoginEn,
    ainaIntro: ainaIntroHi,
    smartBatching: smartBatchingHi,
    profileSetup: profileSetupEn,
    paidUserOnboarding: paidUserOnboardingHi,
  },
} as const;

// Initialize i18next with default configuration
// Apps can override this or use .cloneInstance() if needed
i18n.init({
  lng: "en",
  fallbackLng: "en",
  resources,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;

// Export keys type for type-safety if needed
export type CommonKeys = keyof typeof commonEn;
